import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';
import { useToast } from '@/components/ui/use-toast';

const NotVerifyRequestDialog = ({ open, onOpenChange, submitting, onSubmit }) => {
  const [notVerifyNotes, setNotVerifyNotes] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (notVerifyNotes.trim().length < 5) {
      toast({
        title: 'Notes Required',
        description: 'Verification notes must be at least 5 characters long.',
        variant: 'destructive',
      });
      return;
    }
    onSubmit(notVerifyNotes);
  };

  return (
    <Dialog open={open} onOpenChange={(val) => {
      if (!val) setNotVerifyNotes('');
      onOpenChange(val);
    }}>
      <DialogContent className="sm:max-w-[500px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle className="text-lg font-bold text-foreground">Mark Request Not Verified</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-3">
            <label className="text-sm font-semibold text-foreground">Specify Notes for Non-Verification *</label>
            <textarea
              value={notVerifyNotes}
              onChange={(e) => setNotVerifyNotes(e.target.value)}
              placeholder="e.g. Data discrepancy in weights..."
              className="w-full bg-background border border-border rounded-lg p-2.5 text-sm min-h-[80px] outline-none focus:border-primary text-foreground"
              required
            />
          </div>

          <DialogFooter className="flex justify-end gap-2">
            <CommonButton 
              type="button" 
              variant="outline" 
              onClick={() => onOpenChange(false)} 
              disabled={submitting}
              className="w-44"
            >
              Cancel
            </CommonButton>
            <CommonButton 
              type="submit" 
              variant="default" 
              loading={submitting}
              className="w-44"
            >
              Confirm Not Verified
            </CommonButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NotVerifyRequestDialog;
